import { FeatureFlag } from "@/models/feature/feature";
import RequestMethod from "../models/client/RequestMethod";
import RestResponse from "../models/client/RestResponse";
import { RestClient } from "./restClient";

export type FeatureFlagServiceType = {
  getTenantFeatureFlags: () => RestResponse<FeatureFlag[]>;
  updateTenantFeatureFlag: (
    strategyId: string,
    featureName: string,
    userIds: string[],
    groupIds: string[]
  ) => RestResponse<FeatureFlag>;
  patchRemoveUserFromFeatureFlag: (
    strategyId: string,
    featureName: string,
    userId: string
  ) => RestResponse<FeatureFlag>;
  patchRemoveAllUsersFromFeatureFlag: (
    strategyId: string,
    featureName: string
  ) => RestResponse<FeatureFlag>;
  patchRemoveGroupFromFeatureFlag: (
    strategyId: string,
    featureName: string,
    groupId: string
  ) => RestResponse<FeatureFlag>;
};

const featureFlagServices = (
  client: RestClient,
  path: string
): FeatureFlagServiceType => ({
  getTenantFeatureFlags: async () =>
    await client.fetch<FeatureFlag[]>(RequestMethod.GET, `${path}`),
  updateTenantFeatureFlag: async (
    strategyId: string,
    featureName: string,
    userIds: string[],
    groupIds: string[]
  ) =>
    await client.fetch<FeatureFlag>(
      RequestMethod.PUT,
      `${path}/${strategyId}`,
      {
        featureName,
        userIds,
        groupIds,
      }
    ),
  patchRemoveUserFromFeatureFlag: async (
    strategyId: string,
    featureName: string,
    userId: string
  ) =>
    await client.fetch<FeatureFlag>(
      RequestMethod.PATCH,
      `${path}/${strategyId}/remove-user/${userId}`,
      {
        featureName,
      }
    ),
  patchRemoveAllUsersFromFeatureFlag: async (
    strategyId: string,
    featureName: string
  ) =>
    await client.fetch<FeatureFlag>(
      RequestMethod.PATCH,
      `${path}/${strategyId}/remove-all-users`,
      {
        featureName,
      }
    ),
  patchRemoveGroupFromFeatureFlag: async (
    strategyId: string,
    featureName: string,
    groupId: string
  ) =>
    await client.fetch<FeatureFlag>(
      RequestMethod.PATCH,
      `${path}/${strategyId}/remove-group/${groupId}`,
      {
        featureName,
      }
    ),
});

export default featureFlagServices;
